import { default as index8RJE4PrbPMMeta } from "/builds/web-dev/front/academica/academgen/pages/analytics/index.ts?macro=true";
import { default as _91course_93PgYBtZvrqxMeta } from "/builds/web-dev/front/academica/academgen/pages/course/[course].vue?macro=true";
import { default as authKUKNrjXl7gMeta } from "/builds/web-dev/front/academica/academgen/pages/course/auth.vue?macro=true";
import { default as blankjcoE696e8nMeta } from "/builds/web-dev/front/academica/academgen/pages/course/blank.vue?macro=true";
import { default as mocksPcoyQdE11mMeta } from "/builds/web-dev/front/academica/academgen/pages/mocks.ts?macro=true";
export default [
  {
    name: index8RJE4PrbPMMeta?.name ?? "analytics___ru",
    path: index8RJE4PrbPMMeta?.path ?? "/analytics",
    meta: index8RJE4PrbPMMeta || {},
    alias: index8RJE4PrbPMMeta?.alias || [],
    redirect: index8RJE4PrbPMMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/analytics/index.ts").then(m => m.default || m)
  },
  {
    name: index8RJE4PrbPMMeta?.name ?? "analytics___kz",
    path: index8RJE4PrbPMMeta?.path ?? "/kz/analytics",
    meta: index8RJE4PrbPMMeta || {},
    alias: index8RJE4PrbPMMeta?.alias || [],
    redirect: index8RJE4PrbPMMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/analytics/index.ts").then(m => m.default || m)
  },
  {
    name: _91course_93PgYBtZvrqxMeta?.name ?? "course-course___ru",
    path: _91course_93PgYBtZvrqxMeta?.path ?? "/course/:course()",
    meta: _91course_93PgYBtZvrqxMeta || {},
    alias: _91course_93PgYBtZvrqxMeta?.alias || [],
    redirect: _91course_93PgYBtZvrqxMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/[course].vue").then(m => m.default || m)
  },
  {
    name: _91course_93PgYBtZvrqxMeta?.name ?? "course-course___kz",
    path: _91course_93PgYBtZvrqxMeta?.path ?? "/kz/course/:course()",
    meta: _91course_93PgYBtZvrqxMeta || {},
    alias: _91course_93PgYBtZvrqxMeta?.alias || [],
    redirect: _91course_93PgYBtZvrqxMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/[course].vue").then(m => m.default || m)
  },
  {
    name: authKUKNrjXl7gMeta?.name ?? "course-auth___ru",
    path: authKUKNrjXl7gMeta?.path ?? "/course/auth",
    meta: authKUKNrjXl7gMeta || {},
    alias: authKUKNrjXl7gMeta?.alias || [],
    redirect: authKUKNrjXl7gMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/auth.vue").then(m => m.default || m)
  },
  {
    name: authKUKNrjXl7gMeta?.name ?? "course-auth___kz",
    path: authKUKNrjXl7gMeta?.path ?? "/kz/course/auth",
    meta: authKUKNrjXl7gMeta || {},
    alias: authKUKNrjXl7gMeta?.alias || [],
    redirect: authKUKNrjXl7gMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/auth.vue").then(m => m.default || m)
  },
  {
    name: blankjcoE696e8nMeta?.name ?? "course-blank___ru",
    path: blankjcoE696e8nMeta?.path ?? "/course/blank",
    meta: blankjcoE696e8nMeta || {},
    alias: blankjcoE696e8nMeta?.alias || [],
    redirect: blankjcoE696e8nMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/blank.vue").then(m => m.default || m)
  },
  {
    name: blankjcoE696e8nMeta?.name ?? "course-blank___kz",
    path: blankjcoE696e8nMeta?.path ?? "/kz/course/blank",
    meta: blankjcoE696e8nMeta || {},
    alias: blankjcoE696e8nMeta?.alias || [],
    redirect: blankjcoE696e8nMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/course/blank.vue").then(m => m.default || m)
  },
  {
    name: mocksPcoyQdE11mMeta?.name ?? "mocks___ru",
    path: mocksPcoyQdE11mMeta?.path ?? "/mocks",
    meta: mocksPcoyQdE11mMeta || {},
    alias: mocksPcoyQdE11mMeta?.alias || [],
    redirect: mocksPcoyQdE11mMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/mocks.ts").then(m => m.default || m)
  },
  {
    name: mocksPcoyQdE11mMeta?.name ?? "mocks___kz",
    path: mocksPcoyQdE11mMeta?.path ?? "/kz/mocks",
    meta: mocksPcoyQdE11mMeta || {},
    alias: mocksPcoyQdE11mMeta?.alias || [],
    redirect: mocksPcoyQdE11mMeta?.redirect || undefined,
    component: () => import("/builds/web-dev/front/academica/academgen/pages/mocks.ts").then(m => m.default || m)
  }
]